import {Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import {Directive, Input} from "@angular/core"

@Directive({
  selector:'[minPasswordAgeValidtor]',
  providers:[
    {
      provide:NG_VALIDATORS,
      useExisting:MinPasswordAgeValidtor,
      multi:true
    }
  ]
})
export class MinPasswordAgeValidtor implements Validator{
    @Input() minPasswordAgeValidtor:string
    validate(control:AbstractControl):null|{[key:string]:any}{
      const otherControl=control.parent.get(this.minPasswordAgeValidtor)
      if(otherControl){
        if(otherControl.value<control.value)
        return {
          minPasswordAgeError:true
        }
        return null
      }
    }
}
